<template>
  <div class="table-statistic">
    <div class="table-statistic__back-time">
      <span
        class="font-size-16 secondary-color-txt font-sanpro back-text cursor-pointer"
        @click="handleBackTime"
      >
        <i class="fa fa-angle-left"></i> Trở lại
      </span>
    </div>
    <div class="all-select display-flex">
      <div class="practice-to-book select-custom selectdiv position-rel">
        <select
          class="form-control"
          id="status"
          @change="handelSelectChat"
          name="subjectId"
        >
          <option value="0">Môn - Tất cả</option>
          <option
            v-for="(item, index) of dataSubject"
            :key="index"
            :value="item.subjectId"
          >
            {{ item.name }}
          </option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
      <div class="practice-to-book select-custom selectdiv position-rel">
        <select
          class="form-control"
          id="status"
          @change="handelSelectChat"
          name="type"
          :value="paramProcessChat.type"
        >
          <option
            v-for="(item, index) of dataBookpractice"
            :key="index"
            :value="item.type"
          >
            {{ item.name }}
          </option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
      <div class="practice-to-book select-custom selectdiv position-rel">
        <select
          class="form-control"
          id="status"
          @change="handelSelectChat"
          name="timeType"
        >
          <option
            v-for="(item, index) of dataTime"
            :key="index"
            :value="item.timeType"
          >
            {{ item.name }}
          </option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
    </div>
    <div class="table-learn-process">
      <div class="row">
        <div class="col-lg-12 table-list">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="title-table">{{paramProcessChat.type==2?'Tên luyện tập':'Tên sách'}} </th>
                <th scope="col" class="title-table" v-if="paramProcessChat.type==2">Vị trí</th>
                <th scope="col" class="title-table" v-if="paramProcessChat.type==1">Bộ sách</th>
                <th scope="col" class="title-table" v-if="paramProcessChat.type==2">Chức năng</th>
                <th scope="col" class="title-table">{{paramProcessChat.type==2?'Ngày luyện tập':'Ngày đọc'}} </th>
                <th scope="col" class="title-table" v-if="paramProcessChat.type==2">Câu đúng</th>
                <th scope="col" class="title-table">{{paramProcessChat.type==2?'Thời gian làm':'Thời gian'}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) of dataListProcessChat" :key="index">
                <td class="text-left">
                  <a
                    @click="pageRote(item)"
                    class="font-size-16 font-sanpro-semibold primary-color"
                    >{{ item.name }}</a
                  >
                </td>
                <td data-label="Vị trí :" class="content-col primary-color-txt" v-if="paramProcessChat.type==2">
                  {{ item.position }}
                </td>
                <td data-label="Vị trí :" class="content-col primary-color-txt" v-if="paramProcessChat.type==1">
                  {{ item.position }}
                </td>
                <td
                  v-if="paramProcessChat.type==2"
                  data-label="Chức năng :"
                  class="content-col primary-color-txt"
                >
                  {{ paramProcessChat.type == 1 ? "Đọc sách" : "Luyện tập" }}
                </td>
                <td
                  :data-label="paramProcessChat.type==2?'Ngày luyện tập :':'Ngày đọc :'"
                  class="content-col primary-color-txt"
                >
                  {{ moment(item.createDate).format(formatDate) }}
                </td>
                <td
                   v-if="paramProcessChat.type==2"
                  data-label="Câu đúng :"
                  class="content-col primary-color-txt"
                >
                  {{ item.totalQuestionCorrect }}/{{ item.totalQuestion }}
                </td>
                <td
                  :data-label="paramProcessChat.type==2?'Thời gian làm :':'Thời gian :'"
                  class="content-col primary-color-txt text-center"
                >
                {{ item.timeToDo }}
                <!-- {{item.timeToDo >0 ?hhmmss(item.timeToDo):moment( item.createDate, "HH:mm:ss" ).format("HH:mm:ss")}} -->
                 <!-- {{item.timeToDo >60 ?moment( item.timeToDo/60, "HH:mm" ).format("HH:mm"): moment( item.timeToDo, "mm" ).format("HH:mm")}} -->
                </td>
              </tr>
            </tbody>
          </table>
          <div id="library_end"></div>
        </div>
        <!--           
          <p class="col-12 text-center pagiination-training">
                    <Pagination
                        @eventPagination="getTrainingPagination"
                        :totalPage="pagingData.totalPage"
                        :page="pagingData.pageIndex"
                    />
          </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
// import { STORE_KEY } from "../../_store/constants";
import moment from "moment";
import {
  STORE_KEY,
  TYPE_ACTIVE_ACTIVITY,
  TYPE_READ_BOOK_ACTIVITY,
  TYPE_EXERCISE_ACTIVITY,
  TYPE_EXERCISE_ACTIVITY_EXAM,
  TYPE_EXERCISE_ACTIVITY_THEMATIC,
  TYPE_EXERCISE_ACTIVITY_OTHER
} from "../../_store/constants";
export default {
  data() {
    return {
      pagingData:{},
      typeAcExam: TYPE_EXERCISE_ACTIVITY_EXAM,
      typeAcThematic: TYPE_EXERCISE_ACTIVITY_THEMATIC,
      typeAcExerciseOther: TYPE_EXERCISE_ACTIVITY_OTHER,
      elmEndItem: null,
      formatDate: "HH:ss-DD/MM/YYYY",
      dataTime: [
        { name: "Theo tuần", timeType: 1 },
        { name: "Theo tháng", timeType: 2 },
        { name: "Theo năm", timeType: 3 },
      ],
      dataBookpractice: [
     
        { name: "Luyện tập", type: 2 },
        { name: "Đọc sách", type: 1 }
      ],
      dataListProcessChat:[]
    };
  },
  computed: {
    ...mapState(STORE_KEY, [
      "dataTypePractice",
      "dataBookGroup",
      "getUserInfo",
      "dataSubject",
      "pramPracticeChart",
      "getProcessPracticeChart",
      "paramLeaningProcess",
      "dataListProcessLearing",
      "dataOverSubjectChart",
      "paramProcessChat",
      "displayDetail",
      'changeClass'
      // "dataListProcessChat"
    ]),
  },
  watch:{
    changeClass(){
      this.changeParamProcessChat()
    },
    getUserInfo(newVal) {
      this.classId = newVal.classId;
      this.setParamListProcessChat({
      ...this.paramProcessChat,
      classId: newVal.classId,
      pageIndex: 1,
      pageSize:10
    });
    //   this.getSubjects();
    //   this.getOverviewSubjectChart();
    },
       paramProcessChat:"changeParamProcessChat"
  },
  created(){
        this.changeParamProcessChat()
  },
  mounted() {
    this.elmEndItem = document.getElementById('library_end')
      if (this.elmEndItem) {
        this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
        this.observer.observe(this.elmEndItem)
      }
  },
//    beforeDestroy () {
//     //   this.setParamSearchLesson({...this.paramSearchLessons, filterType: TAB_MEDIA_PAGE_LINK,classId: 0, subjectId: 0, pageLinkGroupId: 0, bookLessonPlanTypeId: 0, pageIndex: 1})
//     //   this.acSetParamFilterBook({...this.paramFilterBook, classId: 0, subjectId: 0, bookGroupId: 0, pageLinkGroupId: 0, scrollData: false })
//     //   this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId: 0, subjectId: 0, bookGroupId: 0, bookLessonPlanTypeId: 0, scrollData: false })
//     //   this.observer.unobserve(this.elmEndItem);
//  },
  methods: {
    ...mapActions(STORE_KEY, [
      "updateUserProfile",
      "actionGetTypePractice",
      "actionGetBookGroup",
      "actionGetSubjects",
      "setPramPracticeChart",
      "actionGetProcessPracticeChart",
      "setParamLearningProcess",
      "actionGetListProcessLearning",
      "actionGetOverviewSubjectChart",
      "setParamListProcessChat",
      "actionGetListProcessChat",
      "actionGetDetailProcessLearningByDate",
      "setDispalyDetail"
    ]),
    moment,
    pad(num) {
      return ("0"+num).slice(-2);
    },
    hhmmss(minutes) {
      var hours = Math.floor(minutes/60)
      minutes = minutes%60;
      return `${this.pad(hours)}:${this.pad(minutes)}`;
    },
    handelSelectChat(e){
     this.dataListProcessChat =[]
      let name =  e.target.name
      this.setParamListProcessChat({...this.paramProcessChat,[name]: e.target.value ,pageIndex:1})
    },
    changeParamProcessChat(){
       this.actionGetListProcessChat(this.paramProcessChat).then(res=>{
           this.pagingData = res.paging
           this.dataListProcessChat  = this.paramProcessChat.pageIndex === 1 ?res.list : [...this.dataListProcessChat, ...res.list];
       })
    },
    handleScrollEnd(){
      if( this.pagingData && this.pagingData.totalPage && this.paramProcessChat.pageIndex < this.pagingData.totalPage){
        
         this.setParamListProcessChat({...this.paramProcessChat, pageIndex: this.paramProcessChat.pageIndex + 1})
      }
    },
    handleBackTime() {
        this.observer.unobserve(this.elmEndItem);
        this.setDispalyDetail(!this.displayDetail)
         this.setParamListProcessChat({...this.paramProcessChat, pageIndex: 1,pageSize:10})
    },
    pageRote(item){
      if(this.paramProcessChat.type ===1){
        this.$router.push({
            name: "ebook-detail",
            params: {
              slug: item.slug,
              id: item.bookId,
            },
        });
      }else{
          // this.$router.push({
          //   name: "exerciseDetail",
          //   params: { id: item.bookId },
          //   query: { danhmuc: item.bookIndexId, cauhoi: item.questionDoneId },
          // })
    switch (item.typePractice) {
        case TYPE_READ_BOOK_ACTIVITY:
          this.$router.push({
            name: "ebook-read-book",
            params: { id: item.bookId, slug: item.slug },
            query: { page: item.pageNo },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY:
          this.$router.push({
            name: "exerciseDetail",
            params: { id: item.bookId },
            query: { danhmuc: item.bookIndexId, cauhoi: item.questionDoneId },
          });
          break;
        case TYPE_ACTIVE_ACTIVITY:
          this.$router.push({
            name: "ebook-detail",
            params: { id: item.bookId, slug: item.slug },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_EXAM:
          this.$router.push({
            name: "exerciseExamQuestion",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 9,
              id: item.examId,
            },
            query: {
              cauhoi: item.questionDoneId
            }
          })
          break;
        case TYPE_EXERCISE_ACTIVITY_THEMATIC:
          this.$router.push({
            name: "exerciseThematicDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 8,
              id: item.chapterId,
            },
            query: {
              cauhoi: item.questionDoneId
            }
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_OTHER:
          this.$router.push({
            name: "exerciseOtherDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 1,
              id: item.chapterId,
            },
            query: {
              cauhoi: item.questionDoneId
            }
          });
          break;
      }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.primary-color{
    color: #0f3dba !important;
    cursor: pointer !important;
}
.arrow_box{
  width: 300px !important;
  .item{
    border: 1px solid red  !important;
  }
}
.table thead th {
  border: none !important;
  color: #40505e !important;
  font-family: sandisplaypro-bold;
}
.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  // font-size: 15px;
}
.title-table {
}
.mt-43 {
  margin-top: 43px;
}
.border-css {
  border: 1px solid #eaeaea;
  border-radius: 16px;
  overflow: hidden;
}
.learn-process {
  padding-bottom: 100px;
  &__excercise {
    // border: 1px solid #eaeaea;
    // border-radius: 16px;
    // overflow: hidden;
    // padding: 17px;
    .title {
      margin-bottom: 25px;
      padding: 17px 17px 0 17px;
    }
    .all-select {
      margin-bottom: 35px;
      padding-left: 17px;
    }
    .result {
      width: 30%;
      padding-left: 17px;
    }
    .target {
      position: absolute;
      right: 50px;
      top: 17px;
      img {
        width: 130px;
      }
      .target-name {
        margin-top: 15px;
      }
    }
    .score-chart {
      margin-top: 20px;
      .bg-chart {
        width: 100%;
      }
      .line {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 32px;
        .bg-success {
          background: red;
        }
        .img-line {
          width: 100%;
        }
      }
      .student {
        position: absolute;
        bottom: 30px;
        // left: 24%;
      }
      .flag {
        position: absolute;
        bottom: 30px;
        right: 18px;
      }
    }
  }
  &__study {
    padding: 17px;
    .title {
      margin-bottom: 25px;
    }
    .all-select {
      margin-bottom: 20px;
    }
  }
  &__overview {
    padding: 17px;
    .chart {
      margin-top: 20px;
    }
  }
}
.table-learn-process {
  margin-top: 25px;
}
.table-statistic {
  &__back-time {
    margin-bottom: 15px;
    .back-text {
      &:hover {
        color: #0f3dba;
      }
    }
  }
}
.select-custom {
  width: 180px;
  margin-right: 20px;
  i {
    color: #0f3dba;
  }
}
.select-custom select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 20px;
  border-radius: 20px;
  height: 30px;
  background: #f3f6fb;
  border: 0;
}

@media screen and (max-width: 1024px) {
  .learn-process__excercise {
    .result {
      width: 60%;
    }
    .all-select {
      margin-bottom: 15px;
    }
    .target img {
      width: 110px;
    }
    .score-chart {
      .flag,
      .student {
        bottom: 17px;
      }
      .img-student,
      .img-flag {
        height: 85px;
      }
    }
    .select-custom {
      width: 150px;
    }
  }
}
@media screen and (max-width: 575px) {
  .learn-process__excercise {
    .all-select {
      display: block !important;
      margin-top: 30px;
      padding: 0 17px;
      .select-custom {
        width: 100%;
        margin-bottom: 15px;
      }
    }
    .target {
      position: unset;
      text-align: center;
    }
    .score-chart {
      margin-top: 70px;
      .flag,
      .student {
        bottom: 10px;
      }
      .img-student,
      .img-flag {
        height: 50px;
      }
      .line {
        bottom: -5px;
      }
    }
  }
  .learn-process__study {
    .all-select {
      display: block;
    }
    .select-custom {
      width: 100%;
      margin-bottom: 15px;
    }
  }
  .table-list table {
    max-width: 100%;
  }
  .table-list table th {
    /*width: 700px;*/
    display: none;
  }
  .table-list table tr {
    border: 1px solid #dee2e6;
    padding: 15px;
    display: block;
  }
  .table-list table td {
    display: block;
    width: 100%;
    text-align: center !important;
    padding: 0;
    border: 0;
  }
  .table-list table td:before {
    content: attr(data-label);
    display: inline-block;
    font-weight: bold;
    margin-right: 8px;
    color: #40505e;
    font-weight: 500;
  }
  .table-statistic {
    .all-select {
      display: block;
    }
    .select-custom {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
@media screen and (max-width: 425px) {
  .learn-process__excercise {
    .select-custom {
      width: 230px;
      margin-bottom: 15px;
    }
    .target {
      right: 15px;
      text-align: center;
    }
    .result {
      width: 100%;
      padding: 0 17px;
    }
  }
  .learn-process__study {
    .select-custom {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
</style>